module.exports = __webpack_public_path__ + "static/media/040.18fd3f6f.wav";


/*****************
 ** WEBPACK FOOTER
 ** ./src/sound/040.wav
 ** module id = 172
 ** module chunks = 0
 **/